<template>
	<TheBox :title="statement.title" :titleLevel="3" :insideTable="true">
		<template #boxheaderRight>
			<div class="has-status" :class="`has-status--${$getStateColor('statement', statement.state)}`">
				{{ $getStateFullLabel('statement', statement.state) }}
			</div>
		</template>

		<div class="flex flex-grow flex--alignstart">
			<span v-if="statement.contact.company">{{ statement.contact.company }} </span>
			<span v-if="statement.createdDate">{{ $formatDate(statement.createdDate) }}</span>
		</div>
		<div class="button-panel">
			<TheButton type="default" @buttonclick="goToDetailPage(statement)">Details zur Stellungnahme</TheButton>
		</div>
	</TheBox>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TheBox from '../TheBox.vue';
import TheButton from '../TheButton.vue';
import { StatementResponse } from '../../types/types';

export default defineComponent({
	name: 'BoxStatement',
	data() {
		return {};
	},
	components: {
		TheBox,
		TheButton,
	},
	props: {
		statement: {
			type: Object,
			required: true,
		},
	},
	methods: {
		goToDetailPage(row: StatementResponse) {
			this.$router.push({ name: 'StellungnahmeDetail', params: { id: String(row.id) } });
		},
		getSplittedUsername(part = 'name') {
			console.log(this.statement);
			// splits the username/email so it breaks after the @ character on mobile
			let namePart = '';
			let emailPart = '';
			if (!this.statement.contact.userName) namePart = '';
			if (!this.statement.contact.userName.includes('@')) namePart = this.statement.contact.userName;
			else {
				const [name, email] = this.statement.contact.userName.split('@');
				namePart = name;
				emailPart = '@' + email;
			}

			if (part == 'name') return namePart;
			if (part == 'email') return emailPart;
		},
	},
});
</script>

<style lang="scss" scoped>
.box {
	> .flex {
		> span {
			display: inline-block;
			width: 100%;
		}
	}
}
</style>
